<template>
    <div class="footer-box">
         <copyrightInformation></copyrightInformation>
    </div>
</template>

<script>
import copyrightInformation from '@/components/copyrightInformation'
    export default {
        components: {copyrightInformation},
    }
</script>

<style lang="scss" scoped>
.footer-box{
    margin-top: 30px;
    padding: 30px 40px;
    background-color: #fff;
    text-align: right;
}
</style>